import React, { Fragment, useState, useEffect, useRef } from "react";
import Search from "../Search";
import Sidebar from "../Sidebar";
import MobileHeader from "./MobileHeader";
import { useTranslation } from "react-i18next";

import logoBig from "../../assets/images/logo-no-background-big.png";
import i18n from "../../i18n";
import { Link } from "react-router-dom";

const Header = ({ headernumber }) => {
  const { t, i18n } = useTranslation();

  const [sidebarTrigger, setSidebarTrigger] = useState(false);
  const [searchBarTrigger, setSearchBarTrigger] = useState(false);
  const [mobileHeader, setMobileHeader] = useState(false);
  const headerInnerRef = useRef(null);
  const activeTab = window.location.pathname.replace(/^\//, "") || "home";

  useEffect(() => {
    if (mobileHeader) {
      document.body.classList.add("mobile-menu-visible");
    } else {
      document.body.classList.remove("mobile-menu-visible");
    }
    return () => document.body.classList.remove("mobile-menu-visible");
  }, [mobileHeader]);

  useEffect(() => {
    const headerBar = headerInnerRef.current;
    const headerEl = headerBar?.closest(".main-header");
    if (!headerBar || !headerEl) return;

    const syncHeaderMetrics = () => {
      const barHeight = headerBar.getBoundingClientRect().height;
      const topOffset = parseFloat(getComputedStyle(headerEl).top) || 0;
      const totalOffset = topOffset + barHeight + 8;

      document.documentElement.style.setProperty(
        "--header-bar-height",
        `${barHeight}px`
      );
      document.documentElement.style.setProperty(
        "--header-top-offset",
        `${topOffset}px`
      );
      document.documentElement.style.setProperty(
        "--header-total-offset",
        `${totalOffset}px`
      );
    };

    syncHeaderMetrics();

    const resizeObserver = new ResizeObserver(syncHeaderMetrics);
    resizeObserver.observe(headerBar);

    window.addEventListener("resize", syncHeaderMetrics);
    return () => {
      resizeObserver.disconnect();
      window.removeEventListener("resize", syncHeaderMetrics);
    };
  }, [i18n.language]);

  const getTabPath = (tab) => (tab === "home" ? "/" : `/${tab}`);

  function mobileHeaderTrigger() {
    setMobileHeader(!mobileHeader);
  }

  const tabs = [
    "home",
    "about",
    "rooms",
    "dining",
    "sport",
    "events",
    "offers",
    "reviews",
    "gallery",
    "contact",
  ];
  const clickHandler = () => {
    window.scrollTo(10, 0);
  };
  return (
    <Fragment>
      <header
        className={`main-header header-style-one ${
          headernumber ? "" : "style-two"
        }`}
      >
        <div className="header-upper">
          <div className="auto-container">
            <div className="inner-container" ref={headerInnerRef}>
              <div className="header-brand">
                <Link to="/" onClick={clickHandler}>
                  <img src={logoBig} alt="Hotel Admiral" />
                </Link>
              </div>
              <div className="nav-outer">
                <button
                  type="button"
                  className="mobile-nav-toggler"
                  onClick={mobileHeaderTrigger}
                  aria-label="Open menu"
                >
                  <span className="mobile-nav-toggler__icon" aria-hidden="true" />
                </button>
                <nav className="main-menu navbar-expand-md navbar-light">
                  <div className="collapse navbar-collapse show clearfix">
                    <ul className="navigation">
                      {tabs.map((tab, idx) => (
                        <li key={idx}>
                          <Link
                            onClick={clickHandler}
                            to={getTabPath(tab)}
                            className={
                              activeTab === tab ? "navigation-active-tab" : ""
                            }
                          >
                            {t(tab === "rooms" ? "accommodation" : tab)}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                </nav>
              </div>
              <TranslationDropdown />
            </div>
          </div>
        </div>
        <div
          className="nav-overlay"
          style={{ display: sidebarTrigger ? "block" : "none" }}
          onClick={() => setSidebarTrigger(false)}
        >
          <div className="cursor" />
          <div className="cursor-follower" />
        </div>
      </header>
      <MobileHeader
        isOpen={mobileHeader}
        tabs={tabs}
        closeMobileHeader={() => setMobileHeader(false)}
        activeTab={activeTab}
      />
      <Sidebar
        open={sidebarTrigger}
        closeSidebar={() => setSidebarTrigger(false)}
      />
      <Search
        open={searchBarTrigger}
        closeSidebar={() => setSearchBarTrigger(false)}
      />
    </Fragment>
  );
};
const TranslationDropdown = () => {
  const { i18n: i18nInstance } = useTranslation();
  const languages = ["bg", "en", "de", "ro"];
  const currentLang = (i18nInstance.language || "bg").slice(0, 2);

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
    localStorage.setItem("hotel-admiral-language", lang);
  };

  return (
    <div className="lang-switcher dropdown">
      <button type="button" className="lang-switcher__toggle" aria-haspopup="true">
        <i className="fa fa-globe" aria-hidden="true" />
        <span>{currentLang.toUpperCase()}</span>
        <i className="fa fa-chevron-down lang-switcher__caret" aria-hidden="true" />
      </button>
      <ul className="translation-dropdown-content">
        {languages.map((lang) => (
          <li
            key={lang}
            className={currentLang === lang ? "lang-switcher__option--active" : ""}
            onClick={() => changeLanguage(lang)}
          >
            {lang.toUpperCase()}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Header;
